<div class="inner-page-wrapper flex flex-col gap-24 py-40">
    <div class="md:mx-auto md:max-w-[1004px]">
        <div
            class="font-headline text-24 md:text-34 leading-29 font-medium text-black empty:hidden md:text-center md:leading-41"
        >
            <ng-content select="[headline]" />
        </div>
        <div class="text-16 mt-12 leading-27 text-black empty:hidden md:text-center">
            <ng-content select="[text]" />
        </div>
    </div>
    <div
        class="mx-auto grid grid-cols-2 gap-16 md:mt-40 md:mb-[26px] md:max-w-[1004px] md:gap-56"
        [ngClass]="`lg:grid-cols-${facts().length}`"
    >
        @for (item of facts(); track $index) {
            <div class="flex flex-col items-center">
                <div class="flex items-end md:justify-center">
                    <span class="font-headline text-50 leading-58 font-medium text-black md:text-[74px] md:leading-78">
                        {{ item.value }}
                    </span>
                    <span
                        class="font-headline text-18 md:text-20 mb-6 ml-4 leading-27 text-black md:mb-8 md:leading-30"
                    >
                        {{ item.unit }}
                    </span>
                </div>
                @let label = item.label | footnotes;
                <span
                    class="text-14 md:text-16 text-center leading-21 text-black md:mt-12 md:leading-27"
                    [innerHTML]="label()"
                ></span>
            </div>
        }
    </div>
    <div class="flex flex-col gap-24 md:mx-auto md:grid md:grid-cols-2 md:gap-40">
        <a
            class="button-primary col-span-2"
            [hyundaiRouterLink]="primaryButton()"
            [trackingElTarget]="primaryButton()"
            tracking
            trackingElType="button"
            trackingElEvent="engagement_click"
            trackingElLabel="Test Drive"
        >
            {{ primaryButtonText() }}
        </a>
    </div>
    @if (externalLink() && externalLinkText()) {
        <a ui-m010-c025-icon-link-external class="mx-auto" [hyundaiRouterLink]="externalLink()">
            {{ externalLinkText() }}
        </a>
    }
</div>
